import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { Context } from "../context";
import uniqid from "uniqid";

export function MenuCalendar(props) {
  const context = useContext(Context);

  return (
    <div className="x_cal0">
      <div className="x_filters_title">
        <div className="x_cal_month">October 2022</div>
        <div className="x_cal_lr">
          <div className="x_cal_l">
            <div>chevron_left</div>
          </div>
          <div className="x_cal_l">
            <div>chevron_right</div>
          </div>
        </div>
      </div>
      <div className="x_cal_container">
        <div className="x_cal_day x_cal_day--day">
          <div>S</div>
        </div>
        <div className="x_cal_day x_cal_day--day">
          <div>M</div>
        </div>
        <div className="x_cal_day x_cal_day--day">
          <div>T</div>
        </div>
        <div className="x_cal_day x_cal_day--day">
          <div>W</div>
        </div>
        <div className="x_cal_day x_cal_day--day">
          <div>T</div>
        </div>
        <div className="x_cal_day x_cal_day--day">
          <div>F</div>
        </div>
        <div className="x_cal_day x_cal_day--day">
          <div>S</div>
        </div>

        <div className="x_cal_day x_cal_day--inact">
          <div>30</div>
        </div>
        <div className="x_cal_day x_cal_day--inact">
          <div>31</div>
        </div>
        <div className="x_cal_day">
          <div>1</div>
        </div>
        <div className="x_cal_day">
          <div>2</div>
        </div>
        <div className="x_cal_day">
          <div>3</div>
        </div>
        <div className="x_cal_day">
          <div>4</div>
        </div>
        <div className="x_cal_day">
          <div>5</div>
        </div>
        <div className="x_cal_day">
          <div>6</div>
        </div>
        <div className="x_cal_day">
          <div>7</div>
        </div>
        <div className="x_cal_day">
          <div>8</div>
        </div>
        <div className="x_cal_day">
          <div>9</div>
        </div>
        <div className="x_cal_day">
          <div>10</div>
        </div>
        <div className="x_cal_day">
          <div>11</div>
        </div>
        <div className="x_cal_day">
          <div>12</div>
        </div>
        <div className="x_cal_day">
          <div>13</div>
        </div>
        <div className="x_cal_day">
          <div>14</div>
        </div>
        <div className="x_cal_day">
          <div>15</div>
        </div>
        <div className="x_cal_day">
          <div>16</div>
        </div>
        <div className="x_cal_day">
          <div>17</div>
        </div>
        <div className="x_cal_day">
          <div>18</div>
        </div>
        <div className="x_cal_day">
          <div>19</div>
        </div>
        <div className="x_cal_day">
          <div>20</div>
        </div>
        <div className="x_cal_day">
          <div>21</div>
        </div>
        <div className="x_cal_day">
          <div>22</div>
        </div>
        <div className="x_cal_day">
          <div>23</div>
        </div>
        <div className="x_cal_day">
          <div>24</div>
        </div>
        <div className="x_cal_day">
          <div>25</div>
        </div>
        <Link to='/calendar/2021/10/26'
          className="x_cal_day"
          // onClick={() => context.handles["setNewDate"]("10/26/2021")}
        >
          <div>26</div>

          {context["state"]["activeDate"] === "10/26/2021" && (
            <div className="x_cal_active" />
          )}
        </Link>
        <Link to='/calendar/2021/10/27'
          className="x_cal_day"
          onClick={() => context.handles["setNewDate"]("10/27/2021")}
        >
          <div>27</div>
          {context["state"]["activeDate"] === "10/27/2021" && (
            <div className="x_cal_active" />
          )}
        </Link>
        <div className="x_cal_day">
          <div>28</div>
        </div>
        <div className="x_cal_day">
          <div>29</div>
        </div>
        <div className="x_cal_day">
          <div>30</div>
        </div>
        <div className="x_cal_day x_cal_day--inact">
          <div>1</div>
        </div>
        <div className="x_cal_day x_cal_day--inact">
          <div>2</div>
        </div>
        <div className="x_cal_day x_cal_day--inact">
          <div>3</div>
        </div>
        <div className="x_cal_day x_cal_day--inact">
          <div>4</div>
        </div>
        <div className="x_cal_day x_cal_day--inact">
          <div>5</div>
        </div>
        <div className="x_cal_day x_cal_day--inact">
          <div>6</div>
        </div>
        <div className="x_cal_day x_cal_day--inact">
          <div>7</div>
        </div>
        <div className="x_cal_day x_cal_day--inact">
          <div>8</div>
        </div>
        <div className="x_cal_day x_cal_day--inact">
          <div>9</div>
        </div>
        <div className="x_cal_day x_cal_day--inact">
          <div>10</div>
        </div>
      </div>
    </div>
  );
}
